import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type UserlikeChatbotModuleSpecsFragment } from '../../../../api/fragments/UserlikeChatbotModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { useUserlikeChatbotSettingsDrawer } from './UserlikeChatbotSettingsDrawer';

export type UserlikeChatbotSettingsEmptyListProps = {
    module: UserlikeChatbotModuleSpecsFragment;
};

const UserlikeChatbotSettingsEmptyList = ({ module }: UserlikeChatbotSettingsEmptyListProps) => {
    const { t } = useTranslation(['userlikeChatbotModuleDetails']);
    const drawer = useUserlikeChatbotSettingsDrawer(module.id);

    return (
        <>
            <NoItemResult
                extra={
                    <Button onClick={drawer.open} type="primary">
                        {t('userlikeChatbotModuleDetails:emptyList.settings.noData.action')}
                    </Button>
                }
                subTitle={t('userlikeChatbotModuleDetails:emptyList.settings.noData.message')}
            />
            {drawer.render()}
        </>
    );
};

export default UserlikeChatbotSettingsEmptyList;
